import { render } from "./NLPDataList.vue?vue&type=template&id=35c55008"
import script from "./NLPDataList.vue?vue&type=script&lang=js"
export * from "./NLPDataList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__